export interface UrlParamPart {
  readonly plan: { readonly key_name: string; key_value: string }
  readonly actuals: { readonly key_name: string; key_value: string }
  readonly range: { readonly key_name: string; key_value: string }
  readonly lang: { readonly key_name: string; key_value: string }
  readonly scid: { readonly key_name: string; key_value: string }
}

export interface UrlSectionCtxPart {
  readonly ANALYSIS: { readonly name: string; readonly path: string }
  readonly DASHBOARD: { readonly name: string; readonly path: string }
  readonly FINS: { readonly name: string; readonly path: string }
  readonly PLAN: { readonly name: string; readonly path: string }
}
export interface UrlCtxPart extends UrlSectionCtxPart {
  readonly ROOT: { readonly name: string; readonly path: string }
  readonly ENTER_EMAIL: { readonly name: string; readonly path: string }
  readonly OTP: { readonly name: string; readonly path: string }
  readonly USER_APP_SETTINGS: { readonly name: string; readonly path: string }
  readonly PROFILE_SETTINGS: { readonly name: string; readonly path: string }
  readonly ORGANIZATION_SETTINGS: { readonly name: string; readonly path: string }
  readonly COMPANIES_SETTINGS: { readonly name: string; readonly path: string }
  readonly USER_MANAGEMENT: { readonly name: string; readonly path: string }
  readonly BILLING: { readonly name: string; readonly path: string }

  readonly DATA_MANAGEMENT_ORG: { readonly name: string; readonly path: string }
  readonly DATA_ORG: { readonly name: string; readonly path: string }
  readonly DATA_FSD: { readonly name: string; readonly path: string }
  readonly DATA_FSD_CONFIRM: { readonly name: string; readonly path: string }
  readonly DATA_COMP: { readonly name: string; readonly path: string }
  readonly DATA_MANAGEMENT_COMP: { readonly name: string; readonly path: string }
  readonly DATA_UPLOAD: { readonly name: string; readonly path: string }
  readonly DATA_MAPPING: { readonly name: string; readonly path: string }
  readonly DATA_MAPPING_CONFIRM: { readonly name: string; readonly path: string }

  readonly CREATE_ACCOUNT: { readonly name: string; readonly path: string }
  readonly CREATE_ACCOUNT_HAVING_ORG: { readonly name: string; readonly path: string }

  readonly SElECT_PAYMENT_PLAN: { readonly name: string; readonly path: string }

  readonly WELCOME: { readonly name: string; readonly path: string }
  readonly ONBOARDING_UPLOAD_DATA: { readonly name: string; readonly path: string }
  readonly ONBOARDING_COMPLETE: { readonly name: string; readonly path: string }
  readonly ONBOARDING_FINSTMT_DESIGN: { readonly name: string; readonly path: string }
  readonly ONBOARDING_FINSTMT_DESIGN_CONFIRM: { readonly name: string; readonly path: string }
  readonly ONBOARDING_FINSTMT_MAPPING: { readonly name: string; readonly path: string }
  readonly ONBOARDING_FINSTMT_MAPPING_CONFIRM: { readonly name: string; readonly path: string }

  readonly ORG: { readonly name: string; readonly path: string }
  readonly ORG_VIEW: { readonly name: string; readonly path: string }
  readonly COMP_VIEW: { readonly name: string; readonly path: string }
  readonly NO_ACCESS: { readonly name: string; readonly path: string }

  /**
   * monthly, yearly, diff
   */
  readonly DISPLAY_MODE: { readonly name: string; readonly path: string }
  /**
   * pnl, bs, cf
   */
  readonly FPNA_FSTMT: { readonly name: string; readonly path: string }
}

export const urlSectionCtxPartObj: UrlSectionCtxPart = {
  // TODO: add the display_mode and fstmt_view for FINS, PLAN, ANALYSIS.
  //
  //  NO. NO. PLEASE DO NOT ADD THEM HERE.
  //  THEY SHOULD BE HANDLED IN THE MIDDLEWARE OF the index.vue.
  //  SEE /dashboard/index.vue FOR EXAMPLE.
  //  -- @rrmn
  //
  ANALYSIS: { name: 'analysis', path: '/org/:orgId/comp/:compId/analysis' },
  DASHBOARD: { name: 'dashboard', path: '/org/:orgId/comp/:compId/dashboard' },
  FINS: { name: 'financials', path: '/org/:orgId/comp/:compId/financials' },
  PLAN: { name: 'plan', path: '/org/:orgId/comp/:compId/plan' },
}

/**
 * This is to be used widely in the app, so no key or unsupported key should be added here.
 */
export const urlCtxPartObj: UrlCtxPart = {
  ROOT: { name: 'root', path: '/' },
  ENTER_EMAIL: { name: 'enter_email', path: '/enter-email' },
  OTP: { name: 'enter_otp', path: '/enter-otp' },

  USER_APP_SETTINGS: { name: 'user_app_settings', path: '/org/:orgId/settings' },
  PROFILE_SETTINGS: { name: 'profile_settings', path: '/org/:orgId/settings/profile' },
  ORGANIZATION_SETTINGS: { name: 'organization_settings', path: '/org/:orgId/settings/organization' },
  COMPANIES_SETTINGS: { name: 'companies_settings', path: '/org/:orgId/settings/companies' },
  USER_MANAGEMENT: { name: 'user_management', path: '/org/:orgId/settings/users' },
  BILLING: { name: 'billing', path: '/org/:orgId/settings/billing' },

  DATA_MANAGEMENT_ORG: { name: 'data_management', path: '/org/:orgId/data-management' },
  DATA_ORG: { name: 'data_org', path: '/org/:orgId/data-management/organization' },
  DATA_FSD: { name: 'data_fsd', path: '/org/:orgId/data-management/organization/fsd/edit' },
  DATA_FSD_CONFIRM: { name: 'data_fsd_confirm', path: '/org/:orgId/data-management/organization/fsd/confirm' },
  DATA_COMP: { name: 'data_comp', path: '/org/:orgId/data-management/companies' },
  DATA_MANAGEMENT_COMP: { name: 'data_management_comp', path: '/org/:orgId/comp/:compId/data-management' },
  DATA_UPLOAD: { name: 'data_upload', path: '/org/:orgId/data-management/companies/comp/:compId/upload' },
  DATA_MAPPING: { name: 'data_mapping', path: '/org/:orgId/data-management/companies/comp/:compId/mapping/edit' },
  DATA_MAPPING_CONFIRM: { name: 'data_mapping_confirm', path: '/org/:orgId/data-management/companies/comp/:compId/mapping/confirm' },

  CREATE_ACCOUNT: { name: 'create_account', path: '/org/new' },
  CREATE_ACCOUNT_HAVING_ORG: { name: 'create_account_having_organization', path: '/new/addorg' },

  SElECT_PAYMENT_PLAN: { name: 'org-orgId-onboarding-select-plan', path: '/org/:orgId/select-plan' },

  WELCOME: { name: 'welcome', path: '/org/:orgId/welcome' },
  ONBOARDING_UPLOAD_DATA: { name: 'Upload data', path: '/org/:orgId/onboarding/upload' },
  ONBOARDING_FINSTMT_DESIGN: { name: 'Statement design', path: '/org/:orgId/onboarding/fsd/edit' },
  ONBOARDING_FINSTMT_DESIGN_CONFIRM: { name: 'Statement design confirm', path: '/org/:orgId/onboarding/fsd/confirm' },
  ONBOARDING_FINSTMT_MAPPING: { name: 'Mapping', path: '/org/:orgId/onboarding/mapping/edit' },
  ONBOARDING_FINSTMT_MAPPING_CONFIRM: { name: 'Mapping confirm', path: '/org/:orgId/onboarding/mapping/confirm' },
  ONBOARDING_COMPLETE: { name: 'onboarding_complete', path: '/org/:orgId/onboarding/complete' },

  ORG: { name: 'org', path: '/org' },
  ORG_VIEW: { name: 'org_view', path: '/org/:orgId' },
  COMP_VIEW: { name: 'comp_view', path: '/comp/:compId' },
  NO_ACCESS: { name: 'no_access', path: '/org/:orgId/no-access' },

  DISPLAY_MODE: { name: 'scope', path: '/:display_mode' },
  FPNA_FSTMT: { name: 'fstmt', path: '/:fstmt_view' },
  ...urlSectionCtxPartObj,
}

/**
 * This is to be used widely in the app, so no key or unsupported key should be added here.
 * key_value is just a placeholder, it should be replaced with actual value.
 */
export const urlParamPartObj: UrlParamPart = {
  actuals: { key_name: 'actuals', key_value: '' },
  plan: { key_name: 'plan', key_value: '' },
  range: { key_name: 'range', key_value: '' },
  lang: { key_name: 'lang', key_value: '' },
  scid: { key_name: 'scid', key_value: '' },
}

export class StcsRouteBuilder {
  private ctx_parts: string[] = []
  private param_parts: string[] = ['?']

  appendParam(part: { readonly key_name: string; key_value: string }): this {
    this.param_parts.push(`${part.key_name}=${part.key_value}`)
    return this
  }
  append(part: { name: string; path: string }): this {
    this.ctx_parts.push(part.path)
    return this
  }
  appendAll(part_list: { readonly name: string; readonly path: string }[]): this {
    part_list.forEach((part) => this.ctx_parts.push(part.path))
    return this
  }

  toString(): string {
    const ctx_path = this.ctx_parts.join('').replace('//', '/')
    const param_path = this.param_parts.length > 1 ? this.param_parts.join('&').replace('&&', '&') : ''
    return `${ctx_path}${param_path}`
  }
}
